"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteDateField = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Formatter_1 = require("../Formatter");
var TextField_1 = require("../TextField");
/**
 * AutoCompleteDateField
 */
var AutoCompleteDateField = function (props) {
    // Extract known attributes from props into variables
    var children = props.children, errormessage = props.errormessage, forwardRef = props.forwardRef, helptext = props.helptext, id = props.id, isValid = props.isValid, label = props.label, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, // placeholder allowed on autocomplete
    required = props.required, screenreadertext = props.screenreadertext, value = props.value, attributes = __rest(props, ["children", "errormessage", "forwardRef", "helptext", "id", "isValid", "label", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "screenreadertext", "value"]) // tslint:disable-line
    ;
    attributes.type = 'inline-date';
    attributes.onKeyDown = Formatter_1.onDateInput;
    attributes.onKeyUp = Formatter_1.FormatDateInput;
    attributes.onFocus = Formatter_1.onDateInputFocus;
    attributes.onBlur = function (event) {
        (0, Formatter_1.onDateInputBlur)(event);
        if (onBlur) {
            onBlur(event);
        }
    };
    attributes.onClick = Formatter_1.onDateInputMouseCLick;
    var screenHelpText = props.screenreadertext ? props.screenreadertext : props.helptext;
    var screenHelpId = id + "-readeralert";
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "sr-only", id: screenHelpId },
            " ",
            screenHelpText,
            " "),
        React.createElement(TextField_1.TextField, __assign({}, props, attributes))));
};
exports.AutoCompleteDateField = AutoCompleteDateField;
// tslint:disable no-string-literal
exports.AutoCompleteDateField['propTypes'] = {
    errormessage: PropTypes.string,
    helptext: PropTypes.string,
    id: PropTypes.string.isRequired,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    /* Name will default to ID if not provided. ID is required for linking label with input */
    name: PropTypes.string,
    noscreenReaderText: function (props) {
        if (typeof props['helptext'] === 'undefined' || typeof props['screenreadertext'] === 'undefined') {
            return new Error('screenreadertext or helpertext is required.');
        }
        return;
    },
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    required: PropTypes.bool,
    screereadertext: PropTypes.string,
    value: PropTypes.string.isRequired,
};
// tslint:enable no-string-literal
